// extracted by mini-css-extract-plugin
export default {"root":"SpaceWrapper_root__Q7t-z","padding":"SpaceWrapper_padding__8EXSe"};